/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('.flickitySlide').flickity({
  // options
  cellAlign: 'left',
  prevNextButtons: false,
  autoPlay: 4500,
  fade: true,
  contain: true
});

// mainPrice = $('.hiddenPrice').text();
// OnePrice = $.trim(mainPrice);
// subPrice = mainPrice * 0.8;

// $('.buttonPrice').html('£' + subPrice.toFixed(2));

// $(document).on('change', 'input.rc-radio__input', function() {
//   	$('.txtBase').removeClass('active');
//   	$('.ProductMeta__Text span').removeClass('active');
  
//   	if($(this).closest('.rc-radio').hasClass('subscription-radio')) {
//       	$('.txtSubscribe').addClass('active');
//       	$('.ProductMeta__Text span.Sub').addClass('active');
      
//      	$('.buttonPrice').html('£' + subPrice.toFixed(2));
//     } else {
//       	$('.txtPurchase').addClass('active');
//       	$('.ProductMeta__Text span.One').addClass('active');
//       	$('.buttonPrice').html('£' + OnePrice);
//     }
// });

// $(document).on('wheel', (function(e) {
//   if (e.originalEvent.deltaY < 0) {
//     console.log('scroll up')
//   }else{
//     console.log('scroll down')
//   }
// }));

// $(document).on('scroll', (function(e) {
//   if (e.originalEvent.deltaY < 0) {
//     console.log('scroll up')
//   }else{
//     console.log('scroll down')
//   }
// }));
var lastScrollTop = 0;
document.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
  var st = window.pageYOffset || document.documentElement.scrollTop; 
  if (st > lastScrollTop) {
    document.getElementById('section-header').classList.add('scrolling-down');
    document.getElementById('section-header').classList.remove('scrolling-up');
  } else if (st < lastScrollTop) {
    document.getElementById('section-header').classList.add('scrolling-up');
    document.getElementById('section-header').classList.remove('scrolling-down');
  }
  lastScrollTop = st <= 0 ? 0 : st;
}, false);

// Auto-open cart drawer on product added
document.addEventListener("product:added", function(event) {
  var cartDrawer = document.getElementById("sidebar-cart");
  // Only click the cart icon when the drawer is closed: on an open drawer the click isn't intercepted and the link goes to /cart
  if (cartDrawer && cartDrawer.getAttribute("aria-hidden") !== "false") {
    // Use the proper drawer API to open it (triggers the open button click)
    var openButton = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (openButton) {
      openButton.click();
    }
  }
  if (typeof reloadCartDrawerContent === "function") {
    reloadCartDrawerContent();
  } else {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
});

// Failsafe: Ensure no-scroll class and inline overflow styles are always removed when drawer is closed
// This fixes intermittent scroll lock issues on PDP
(function() {
  function cleanupScrollLock() {
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    // Remove inline overflow style that blocks scrolling
    document.body.style.overflow = '';
  }

  // Hook into drawer close button clicks
  document.addEventListener('click', function(e) {
    var target = e.target;
    // Check if it's a close drawer button for the cart
    if (target.matches('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]') ||
        target.closest('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]')) {
      // Small delay to ensure the drawer's close method completes
      setTimeout(cleanupScrollLock, 50);
    }
  }, true);

  // Also handle when clicking on the page overlay to close
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('PageOverlay') && e.target.classList.contains('is-visible')) {
      setTimeout(cleanupScrollLock, 50);
    }
  }, true);

  // Handle ESC key press to close drawer
  document.addEventListener('keyup', function(e) {
    if (e.keyCode === 27) { // ESC key
      var cartDrawer = document.getElementById("sidebar-cart");
      if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
        setTimeout(cleanupScrollLock, 50);
      }
    }
  });
})();
